export default "__VITE_ASSET__uEbE18Qm__"